import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-temp-modb-ms25',
  templateUrl: './lcon-temp-modb-ms25.component.html',
  styleUrls: ['./lcon-temp-modb-ms25.component.css']
})
export class LconTempModbMs25Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
